import { handleClickCard } from "../../../../functions/functions";
import './momioButton.sass'
/**
 * Componente individual para cada botón de momio/apuesta
 * Renderiza un botón clickeable que abre la URL de apuestas en nueva pestaña
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.url - URL del momio para redirigir a la casa de apuestas
 * @param {string} props.value - Valor numérico del momio a mostrar
 * @param {string} props.className - Clases CSS adicionales para personalización
 * @param {boolean} props.isMayor - Aplica estilo "mayor" al texto del momio
 * 
 * @returns {JSX.Element} Botón de momio clickeable
 */
export default function MomioButton({ url, value, className = "", isMayor = false }) {
  return (
    <div
      className={`card-body-center-two ${className}`}
      onClick={(e) => handleClickCard(e, url)}
      role="button"
      tabIndex={0}
      aria-label={`Apostar con momio ${value}`}
      title={`Click para apostar - Momio: ${value}`}
    >
      {value && (
        <p className={isMayor ? "mayor" : ""}>
          {value}
        </p>
      )}
    </div>
  );
}
